import { useState } from 'react';

export interface UseCopyToClipboardOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useCopyToClipboard = (text: string, options?: UseCopyToClipboardOptions) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      options?.onSuccess?.();
      // Reset after 3 seconds
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      options?.onError?.(err as Error);
    }
  };

  return { handleCopy, copied };
};
